import AddAssessment from "pages/ManagementPage/AddAssessment/AddAssessment";

export default AddAssessment;
